import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import Save from './save';

registerBlockType('rielstonenew/gen-slider', {
  edit: Edit,
  save: Save,
});
